<!-- eslint-disable max-len -->
<template>
  <div
    :style="[viewActive === 'laptop' ? {paddingLeft: '30px'} : '']"
    class="layout-wrap mx-auto"
  >
    <div
      :class="[
        viewActive === 'laptop' ? 'w-100 justify-content-center' : 'w-75 justify-content-center'
      ]"
      class="d-flex"
    >
      <div class="preview-option">
        <div
          v-for="view in views"
          :key="view.id"
          :class="{ 'active': view.id === viewActive }"
          class="preview"
          @click="changeLayout(view.id)"
        >
          <img :src="require(`@/assets/app-manager/icon/${view.id}.svg`)" >
        </div>
      </div>
    </div>

    <!-- Layout Web -->
    <div
      v-if="viewActive === 'laptop'"
      class="card-layout"
    >
      <!-- Navbar -->
      <div class="dummy-navbar" />
      <div class="wrap-content-web">
        <!-- Sidebar -->
        <div
          id="sidebar-web"
          class="sidebar-web"
        >
          <div>
            <skeleton-sidebar v-if="isLoadingSidebar" />
            <sidebar-menu
              v-if="!isLoadingSidebar"
              ref="sidebarMenu"
              :menus="listPages"
              :is-parent="true"
              :page-selected="selectedPage"
              :icon-options="iconOptions"
              :list-pages="listPages"
              @selected-page="changeSelectedPage"
              @close-create-page="closeCreatePage"
              @save-page="savePage"
              @update-page="updatePage"
              @delete-page="deletePage"
              @reload-pages="getPagesList"
            />

            <!-- Button add menu -->
            <div
              v-if="!isLoadingSidebar"
              id="createPage"
              class="add-page"
              @click="openCreatePage"
            >
              <span>+</span>
              Add Menu
            </div>
          </div>

          <!-- Popover add menu -->
          <b-popover
            v-if="!isLoadingSidebar"
            ref="createPage"
            target="createPage"
            triggers="manual"
            placement="bottom"
            container="sidebar-web"
          >
            <h3>Add Menu</h3>
            <j-form-page
              ref="formPage"
              :is-popover="true"
              :icon-options="iconOptions"
            />
            <div class="d-flex justify-content-end mt-3">
              <button
                class="button-border mr-2"
                @click="closeCreatePage">
                Close
              </button>
              <button
                class="button-blue"
                @click="createPage"
              >
                Save
              </button>
            </div>
          </b-popover>
        </div>

        <!-- Content -->
        <div class="content-web">
          <!-- If loading -->
          <j-skeleton-component v-if="isLoading" />

          <!-- List component -->
          <div
            v-else
            :class="{'have-data': listComponent && listComponent.length > 0}"
            class="section-component"
          >
            <!-- If not have component -->
            <h5 v-if="listComponent.length === 0">No component on this page, drag here for add component</h5>

            <draggable
              v-if="showConfigPage"
              v-model="listComponent"
              :options="{
                animation:300,
                disabled: componentSelected,
              }"
              group="componentLibrary"
              @change="modifyData"
            >
              <div
                v-for="(component, index) in listComponent"
                :key="component.id"
                :class="{
                  'selected': componentIndexSelected === index,
                  'canvas': component.type === 'canvas'
                }"
                class="component-list"
              >
                <!-- Dummy Experience Manager -->
                <template v-if="component.type === 'form_ui' || component.type === 'multiple_form_ui'">
                  <!-- Dummy Table View -->
                  <dummy-table-view
                    v-if="component.info && JSON.parse(component.info).default_view === 'table_view'"
                    :data-component="component"
                  />

                  <!-- Dummy Table Requestor View -->
                  <dummy-table-view
                    v-else-if="component.info && JSON.parse(component.info).default_view === 'table_requester_view'"
                    :data-component="component"
                    :type="'requestor'"
                  />

                  <!-- Dummy Table Approver View -->
                  <dummy-table-view
                    v-else-if="component.info && JSON.parse(component.info).default_view === 'table_approver_view'"
                    :data-component="component"
                    :type="'approver'"
                  />

                  <!-- Dummy Create View -->
                  <dummy-create-detail-view
                    v-else-if="component.info && JSON.parse(component.info).default_view === 'create_view'"
                    :data-component="component"
                    :type="'create'"
                  />

                  <!-- Dummy Detail View -->
                  <dummy-create-detail-view
                    v-else-if="component.info && JSON.parse(component.info).default_view === 'detail_view'"
                    :data-component="component"
                    :type="'detail'"
                  />

                  <!-- Dummy Calendar View -->
                  <dummy-calendar-view
                    v-else-if="component.info && JSON.parse(component.info).default_view === 'calendar_view'"
                    :data-component="component"
                  />

                  <!-- Dummy Export View -->
                  <dummy-export-view
                    v-else-if="component.info && JSON.parse(component.info).default_view === 'export_view'"
                    :data-component="component"
                  />
                </template>

                <!-- Dummy HTML -->
                <dummy-html
                  v-else-if="component.type === 'html'"
                  :data-component="component"
                />

                <!-- Dummy Canvas -->
                <dummy-canvas
                  v-else-if="component.type === 'canvas'"
                  :data-component="component"
                />

                <!-- Dummy Attendance -->
                <dummy-attendance-my-log
                  v-else-if="component.type === 'attendance_my_log'"
                  :data-component="component"
                />
                <dummy-attendance-monitor
                  v-else-if="component.type === 'attendance_monitor'"
                  :data-component="component"
                />
                <dummy-attendance-report
                  v-else-if="component.type === 'attendance_report'"
                  :data-component="component"
                />
                <dummy-attendance-config
                  v-else-if="component.type === 'attendance_config'"
                  :data-component="component"
                />
                <dummy-co-attendance
                  v-else-if="
                    component.type === 'co_attendance_requestor' ||
                      component.type === 'co_attendance_approver'
                  "
                  :data-component="component"
                  :type="component.type === 'co_attendance_requestor' ? 'requestor' : 'approver'"
                />

                <!-- Dummy Leave -->
                <dummy-leave
                  v-else-if="
                    component.type === 'leave_requestor' ||
                      component.type === 'leave_approver' ||
                      component.type === 'leave_monitor'
                  "
                  :data-component="component"
                  :type="component.type.split('_')[1]"
                />
                <dummy-leave-config
                  v-else-if="component.type === 'leave_config'"
                  :data-component="component"
                />
                <dummy-leave-report
                  v-else-if="component.type === 'leave_report'"
                  :data-component="component"
                />

                <!-- Dummy Overtime -->
                <dummy-overtime-config
                  v-else-if="component.type === 'overtime_config'"
                  :data-component="component"
                />
                <dummy-overtime
                  v-else-if="
                    component.type === 'overtime_requestor' ||
                      component.type === 'overtime_approver' ||
                      component.type === 'overtime_monitor'
                  "
                  :data-component="component"
                  :type="component.type.split('_')[1]"
                />
                <dummy-overtime-report
                  v-else-if="component.type === 'overtime_report'"
                  :data-component="component"
                />

                <!-- Dummy Timesheet -->
                <dummy-timesheet-config
                  v-else-if="component.type === 'timesheet_config'"
                  :data-component="component"
                />
                <dummy-timesheet-report
                  v-else-if="component.type === 'timesheet_report'"
                  :data-component="component"
                />
                <dummy-timesheet-approval
                  v-else-if="component.type === 'timesheet_approval'"
                  :data-component="component"
                />

                <!-- Dummy Employee Setup -->
                <dummy-employee-setup
                  v-else-if="component.type === 'employee_setup'"
                  :data-component="component"
                />

                <!-- Dummy User Setup -->
                <dummy-user-setup
                  v-else-if="component.type === 'user_setup'"
                  :data-component="component"
                />

                <!-- Dummy Access Management -->
                <dummy-access-management
                  v-else-if="component.type === 'access_management'"
                  :data-component="component"
                />

                <!-- Dummy Embed URL -->
                <dummy-embed-url
                  v-else-if="component.type === 'embed_url'"
                  :data-component="component"
                />

                <!-- Dummy Hierarchy &  Custom Hierarchy -->
                <dummy-hierarchy
                  v-else-if="
                    component.type === 'hierarchy' ||
                      component.type === 'custom_hierarchy'
                  "
                  :data-component="component"
                  :is-custom="component.type === 'custom_hierarchy'"
                />

                <!-- Default Component -->
                <div
                  v-else
                  class="pt-4"
                >
                  <j-skeleton-component :length="1" />
                </div>

                <!-- Open Tab or Config -->
                <div class="opentab-or-config">
                  <div class="button">
                    <!-- Open Tab -->
                    <div
                      v-if="
                        component.type === 'form_ui' ||
                          component.type === 'multiple_form_ui' ||
                          component.type === 'canvas'
                      "
                      class="open-tab"
                      @click="onOpenNewtab(component)"
                    >
                      <img
                        :src="require('@/assets/automation/open-tab.svg')"
                        width="16"
                      >

                      <!-- Tooltip -->
                      <div class="tooltip-component">Open new tab</div>
                    </div>

                    <!-- Config -->
                    <div
                      class="config"
                      @click="onEditComponent(component, index)"
                    >
                      <img
                        :src="require('@/assets/automation/config.svg')"
                        width="16"
                      >

                      <!-- Tooltip -->
                      <div class="tooltip-component">Configuration</div>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>

    <!-- Layout Mobile -->
    <j-layout-tab-mobile
      v-else-if="viewActive === 'mobile'"
      :list-pages="listPages"
      :page-selected="selectedPage"
      @selected-page="changeSelectedPage"
    />

    <!-- Component Properties -->
    <jComponentProperties
      v-if="componentSelected"
      :id="idComponentProperties"
      :data-master="masterComponent"
      :data-component="componentSelected"
      :data-edit="dataEditComponent"
      :pages-id="selectedPage.id"
      @delete-component="onDeleteComponent"
      @close-configuration="togglePropertiesComponent(false)"
      @refresh-component="getListComponentByPage"
    />
  </div>
</template>

<script>
/* eslint-disable array-callback-return, consistent-return */
import { mapActions, mapState } from 'vuex';
// Components
import draggable from 'vuedraggable';
import jComponentProperties from '@/views/application-manager/detail/jComponentProperties';
import skeletonSidebar from '@/views/application-manager/detail/app-tabs/partials/loading/skeletonSidebar';
import sidebarMenu from '@/views/application-manager/detail/app-tabs/partials/sidebarMenu';
import jLayoutTabMobile from '@/views/application-manager/detail/app-tabs/partials/jLayoutTabMobile';
import jFormPage from '@/views/setting/jFormPage';
// Dummy Component
import DummyTableView from '@/components/dummy/DummyTableView';
import DummyCreateDetailView from '@/components/dummy/DummyCreateDetailView';
import DummyCalendarView from '@/components/dummy/DummyCalendarView';
import DummyExportView from '@/components/dummy/DummyExportView';
import DummyHtml from '@/components/dummy/DummyHtml';
import DummyCanvas from '@/components/dummy/DummyCanvas';
import DummyAttendanceMyLog from '@/components/dummy/DummyAttendanceMyLog';
import DummyAttendanceMonitor from '@/components/dummy/DummyAttendanceMonitor';
import DummyAttendanceReport from '@/components/dummy/DummyAttendanceReport';
import DummyAttendanceConfig from '@/components/dummy/DummyAttendanceConfig';
import DummyCoAttendance from '@/components/dummy/DummyCoAttendance';
import DummyLeave from '@/components/dummy/DummyLeave';
import DummyLeaveConfig from '@/components/dummy/DummyLeaveConfig';
import DummyLeaveReport from '@/components/dummy/DummyLeaveReport';
import DummyOvertimeConfig from '@/components/dummy/DummyOvertimeConfig';
import DummyOvertime from '@/components/dummy/DummyOvertime';
import DummyOvertimeReport from '@/components/dummy/DummyOvertimeReport';
import DummyTimesheetConfig from '@/components/dummy/DummyTimesheetConfig';
import DummyTimesheetReport from '@/components/dummy/DummyTimesheetReport';
import DummyTimesheetApproval from '@/components/dummy/DummyTimesheetApproval';
import DummyEmployeeSetup from '@/components/dummy/DummyEmployeeSetup';
import DummyUserSetup from '@/components/dummy/DummyUserSetup';
import DummyAccessManagement from '@/components/dummy/DummyAccessManagement';
import DummyEmbedUrl from '@/components/dummy/DummyEmbedUrl';
import DummyHierarchy from '@/components/dummy/DummyHierarchy';
// Skeleton
import jSkeletonComponent from '@/views/experience-manager-v2/loading/jSkeletonComponent';

export default {
  components: {
    draggable,
    jComponentProperties,
    skeletonSidebar,
    sidebarMenu,
    jLayoutTabMobile,
    jFormPage,
    DummyTableView,
    DummyCreateDetailView,
    DummyCalendarView,
    DummyExportView,
    DummyHtml,
    DummyCanvas,
    DummyAttendanceMyLog,
    DummyAttendanceMonitor,
    DummyAttendanceReport,
    DummyAttendanceConfig,
    DummyCoAttendance,
    DummyLeave,
    DummyLeaveConfig,
    DummyLeaveReport,
    DummyOvertimeConfig,
    DummyOvertime,
    DummyOvertimeReport,
    DummyTimesheetConfig,
    DummyTimesheetReport,
    DummyTimesheetApproval,
    DummyEmployeeSetup,
    DummyUserSetup,
    DummyAccessManagement,
    DummyEmbedUrl,
    DummyHierarchy,
    jSkeletonComponent,
  },

  data() {
    return {
      isFirstLoad: true,
      isLoadingSidebar: true,
      isLoading: true,
      viewActive: 'laptop',
      views: [
        { id: 'laptop' },
        { id: 'mobile' },
      ],
      listPages: [],
      idPageCreated: null,
      selectedPage: null,
      iconOptions: [],
      showConfigPage: false,
      dataEditPage: null,
      masterComponent: null,
      listComponent: [],
      idComponentProperties: 'component-properties',
      componentSelected: null,
      componentIndexSelected: null,
      dataEditComponent: null,
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['pages_list', 'application_detail']),
    ...mapState('jStorePrivilege', ['organigram_detail']),
    ...mapState('jStoreLogin', ['profile_data']),
    ...mapState('jStoreApplication', ['list_component']),
  },

  watch: {
    selectedPage(val) {
      if (val) {
        this.dataEditPage = {
          title: val.name,
          type: val.type,
          show_option: val.show_option,
          icon: this.iconOptions.find(f => f.id === val.icon_id),
        };
        setTimeout(() => {
          this.showConfigPage = true;
        }, 100);
      } else {
        this.dataEditPage = null;
      }
    },
  },

  created() {
    this.getPagesList();
    this.initIconList();
    if (localStorage.getItem('userCompanyId')) {
      this.actionDetailOrganigram({ user_company_id: Number(localStorage.getItem('userCompanyId')) });
    }
  },

  methods: {
    ...mapActions('jStoreApplication', ['getListComponent', 'deleteComponent']),
    ...mapActions('jStoreSetting', [
      'actionGetPagesList',
      'actionCreatePage',
      'actionUpdatePage',
      'actionDeletePage',
      'actionGetListIcons',
    ]),
    ...mapActions('jStorePrivilege', ['actionCreatePrivilegePage', 'actionDetailOrganigram']),

    getListComponentByPage() {
      this.isLoading = true;
      this.listComponent = [];
      const parameters = {
        limit: 10,
        page: 1,
        column: 'id',
        sort: 'asc',
      };
      const pagesId = this.selectedPage.id;
      this.getListComponent({ params: parameters, pages_id: pagesId }).then((res) => {
        this.listComponent = this._.cloneDeep(res.data);
        this.isLoading = false;
      });
    },

    getPagesList() {
      const applicationId = this.$route.params.applicationId;
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'order',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetPagesList({ applicationId, param }).then((res) => {
        this.setDataPagesList(res.data);
        if (this.idPageCreated) {
          const selected = res.data.filter(r => r.id === this.idPageCreated)[0];
          this.selectedPage = selected;
          this.idPageCreated = null;
        }
        this.getListComponentByPage();
      });
    },

    setDataPagesList(pages) {
      const dataPages = this._.cloneDeep(pages);
      const sortPagesParent = dataPages.filter(page => !page.parent_id);
      const sortPagesChild = dataPages.filter(page => page.parent_id !== 0);

      // Insert parent page
      this.listPages = sortPagesParent.map(page => ({ ...page, parent_id: 0, child: [] }));

      // Insert child page
      sortPagesChild.forEach((page) => {
        const findIndex = this.listPages.findIndex(p => p.id === page.parent_id);
        if (findIndex > -1) this.listPages[findIndex].child.push(page);
      });

      this.isLoadingSidebar = false;

      // Set active page if first load
      if (this.isFirstLoad) {
        const findFirstPageVisible = this.listPages.find(f => f.type === 'visible');
        this.selectedPage = findFirstPageVisible || null;
        this.isFirstLoad = false;
      } else {
        this.isFirstLoad = false;
      }
    },

    async initIconList() {
      const params = {
        page: 1,
        limit: 100,
        column: 'id',
        sort: 'desc',
        query: '',
        query_type: '',
      };
      const res = await this.actionGetListIcons(params);
      if (!res.error) {
        this.iconOptions = res.data.map(val => ({
          name: val.name,
          label: val.name,
          text: val.name,
          id: val.id,
          icon_grey: val.icon_active,
          icon_white: val.icon_white,
          icon_active: val.icon_active,
          is_delete: false,
        }));
      }
    },

    changeLayout(layout) {
      if (layout === 'laptop') this.isShowSidebar = false;
      this.viewActive = layout;
    },

    changeSelectedPage(page) {
      this.showConfigPage = false;
      setTimeout(() => {
        this.selectedPage = page;
        this.getListComponentByPage();
      }, 300);
    },

    openCreatePage() {
      this.$refs.sidebarMenu.closeCreateSubPage();
      this.$refs.createPage.$emit('open');
    },

    closeCreatePage() {
      this.$refs.createPage.$emit('close');
    },

    createPage() {
      this.$refs.formPage.getData().then((data) => {
        const parameter = {
          application_id: this.application_detail.id,
          name: data.titlePage,
          type: data.selectedType,
          icon_id: data.selectedIcon.id,
          show_option: data.displayMode,
          type_platform: 1,
          order: 0,
          parent_id: 0,
        };
        this.savePage(parameter);
      });
    },

    async savePage(param) {
      const res = await this.actionCreatePage(param);
      if (!res.error) {
        this.getPagesList();
        this.closeCreatePage();
        this.$refs.sidebarMenu.closeCreateSubPage();
        this.addPrivilegePage(res.data.id);

        this.showConfigPage = false;
        setTimeout(() => {
          this.selectedPage = res.data;
        }, 300);
      }
    },

    addPrivilegePage(pageId) {
      const params = {
        pages_id: Number(pageId),
        organigram_id: Number(this.organigram_detail[0].id),
      };
      this.actionCreatePrivilegePage(params);
    },

    async updatePage(data) {
      const parameter = {
        page_id: data.idPage,
        application_id: this.selectedPage.application_id,
        name: data.titlePage,
        type: data.selectedType,
        icon_id: data.selectedIcon.id,
        show_option: data.displayMode,
        order: data.orderPage,
        parent_id: data.parentIdPage,
      };
      const res = await this.actionUpdatePage({ parameter, useLoading: true });
      if (!res.error) {
        this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Update Success');
        this.getPagesList();
      }
    },

    deletePage(data) {
      this.$swal({
        title: 'Delete Page',
        html: `Are you sure to delete page "<span style="font-family: Poppins-Medium; font-size: 18px;">${data.name}</span>"?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.value) {
          const res = await this.actionDeletePage(data.id);
          if (!res.error) {
            this.getPagesList();
            this.selectedPage = null;
            this.showConfigPage = false;
          }
        }
      });
    },

    modifyData({ added }) {
      if (added) {
        this.masterComponent = added.element.master_component;
        this.componentSelected = this.listComponent[added.newIndex];
        this.componentIndexSelected = added.newIndex;
        this.togglePropertiesComponent(true);
      }
    },

    openPropertiesComponent(component, index) {
      if (this.componentSelected) {
        if (index !== this.componentIndexSelected) {
          if (!this.componentSelected.info) {
            this.listComponent.splice(this.componentIndexSelected, 1);
          }
          this.togglePropertiesComponent(false);

          setTimeout(() => {
            this.componentSelected = component;
            this.componentIndexSelected = this.listComponent.findIndex(c => c.id === component.id);
            this.togglePropertiesComponent(true);
          }, 250);
        }
      } else {
        this.componentSelected = component;
        this.componentIndexSelected = index;

        this.togglePropertiesComponent(true);
      }
    },

    togglePropertiesComponent(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idComponentProperties);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idComponentProperties);
        if (element) element.classList.remove('show-properties-field');
        if (this.componentSelected.master_component) {
          this.listComponent.splice(this.componentIndexSelected, 1);
        }

        setTimeout(() => {
          this.componentSelected = null;
          this.componentIndexSelected = null;
          this.dataEditComponent = null;
        }, 200);
      }
    },

    onOpenNewtab(component) {
      const componentInfo = JSON.parse(component.info);
      let url = '';
      if (component.type === 'form_ui') {
        url = `${window.location.origin}/#/experience-manager/update/${componentInfo.form_ui_id}`;
      }
      if (component.type === 'multiple_form_ui') {
        url = `${window.location.origin}/#/multiple-experience-manager/update/${componentInfo.form_ui_id}`;
      }
      if (component.type === 'canvas') {
        url = `${window.location.origin}/#/canvas/update/${componentInfo.canvas_id}`;
      }
      window.open(url, '_blank');
    },

    onEditComponent(component, index) {
      const dataComponent = this.list_component.find(c => c.id === component.id);

      this.dataEditComponent = dataComponent;
      this.masterComponent = {
        id: Number(this.dataEditComponent.component_master_id),
        name: this.dataEditComponent.type,
      };
      this.openPropertiesComponent(component, index);
    },

    onDeleteComponent() {
      const dataIndex = this.componentIndexSelected;
      this.$swal({
        title: 'Delete Component',
        html: `Are you sure to delete component "<span style="font-family: Poppins-Medium; font-size: 18px;">${this.listComponent[dataIndex].name}</span>"?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const dataParam = {
            id: this.listComponent[dataIndex].component_master_id,
            component_id: this.listComponent[dataIndex].id,
          };
          this.deleteComponent(dataParam).then((res) => {
            if (!res.error) this.getListComponentByPage();
          });
          this.togglePropertiesComponent(false);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/jLayoutTab.vue